module.exports = __webpack_public_path__ + "static/img/img_home_banner1.edee844b.png";